import { SVGProps } from 'react';

const SvgEarDeaf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="m505 41-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM185 361 41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L151 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm55-249c-70.7 0-128 57.3-128 128 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-97.2 78.8-176 176-176s176 78.8 176 176c0 47.5-18.8 90.6-49.4 122.2-4.8 4.9-6.6 9.9-6.6 13.8 0 75.1-60.9 136-136 136-13.3 0-24-10.7-24-24s10.7-24 24-24c48.6 0 88-39.4 88-88 0-19.1 8.9-35.5 20.1-47.1 22.3-23 35.9-54.4 35.9-88.9 0-70.7-57.3-128-128-128zm0 88c-22.1 0-40 17.9-40 40 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6 39.4-88 88-88s88 39.4 88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-22.1-17.9-40-40-40z" />
  </svg>
);
export default SvgEarDeaf;
